import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  width: 100%;
  padding: 12px 0;
  background: linear-gradient(180deg, rgba(244, 244, 245, 0.72) 0%, #f4f4f5 100%), url("./assets/webb.png");
`

export const IconWithText = styled.div`
  display: flex;
  align-items: center;
  color: ${Color.gray800};
  font-size: 16px;
  margin-right: 12px;

  @media (min-width: 1280px) {
    font-size: 18px;
  }

  & i {
    font-size: 16px;
    color: ${Color.gray800};
    margin-right: 6px;

    @media (min-width: 1280px) {
      font-size: 24px;
    }
  }

  &:nth-child(1) {
    display: none;
  }

  @media (min-width: 640px) {
    &:nth-child(1) {
      display: block;
      display: flex;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
`
